var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('LoveMapIndex'),_c('LoveMapAdmin'),_c('LoveMapSettings'),_c('LoveMapWooCommerce'),_c('TxProductStats')],1)}
var staticRenderFns = []

export { render, staticRenderFns }